<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>
        </div>

       <div class="content" v-else>
           <h1>Import do vyúčtování majitelům licencí</h1>

           <table  class="info-table" style="margin-top: 50px">
               <tr >
                   <td class="info-table__title">
                       Měsíc:
                   </td>
                   <td class="info-table__value info-table__value--date" style="margin-bottom: 20px">
                     <v-date-picker
                         locale="cs-cz"
                         v-model="month"
                         type="month"
                     ></v-date-picker>


                   </td>
               </tr>

             <tr v-if="month">
               <td class="info-table__title">
                 Import od:<br>
                 <span>(Vydavatel)</span>
               </td>
               <td class="info-table__value info-table__value--date" style="margin-bottom: 20px">
                 <v-text-field
                     class="input--smaller"
                     outlined
                     v-model="name"
                 >
                 </v-text-field>
               </td>
             </tr>

               <tr v-if="name">
                   <td class="info-table__title">
                       Nahrát data:
                   </td>
                   <td class="info-table__value info-table__value--date">

                       <v-btn
                               color="primary"
                               class="button--primary"
                               @click="openImport()"
                       >
                           vybrat soubor
                       </v-btn>

                   </td>
               </tr>
           </table>
       </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';
    import moment from 'moment'

    export default {
        name: 'Settings',
        components: {
        },



        data() {
            return {
              month: null,
                years: [],
                loaded: false,
                banners: [],
                errors: {},
                imageUploaded: true,
                currentYear: null,
                items: [],
                publishers: [],
              name: null,
                publisher: null
            }
        },

        created() {

            this.fetchData();

        },
        computed: {
            ...mapState(['profile','import']),

        },
        mounted(){
            //this.loaded = true;
        },
        methods: {
          selectDate(){
            console.log('test', this.month)
          },
            fetchData(){
                this.$axios.get('/admin/publishers').then((response) => {
                    this.publishers = response.data.publishers;
                    this.loaded = true;
                }).catch((e) => {
                    this.loaded = true;
                });


                const years = []
                const dateStart = moment().subtract(20,'y')
                const dateEnd = moment()
                while (dateEnd.diff(dateStart, 'years') >= 0) {
                    years.push(dateStart.format('YYYY'))
                    dateStart.add(1, 'year')
                }


                this.years = years.sort(function(a, b){return b-a});
            },
            openImport(){
                var data = {
                    date: this.month,
                    publisher: this.name
                }
                this.$root.$emit('import-excel', data)
            }


        },
        watch: {

        }
    }
</script>


<style lang="scss">


</style>
